export var ButtonType = {
  Default: 'default',
  Sidebar: 'sidebar'
};